import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { Observable, of, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { SessionService } from '@app/core'
import { Router } from '@angular/router'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(error => this.handleError(error)))
  }

  private handleError(err: HttpErrorResponse): Observable<HttpEvent<unknown>> {
    // We only check for unauthorized errors here
    if (err.status === 401) {
      // if we are unauthorized then clear storage and navigate to login page
      this.sessionService.clearUserAndStorages()
      this.router.navigate(['login'])
      return of(null)
    }
    return throwError(() => err)
  }
}
